import React from 'react';
import { useNavigate } from 'react-router-dom';
import healthCompassLogo from '/icons/logos/health-compass.svg';
import maintenanceIllustration from '/icons/System-maintenance-reel.svg';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center m-[50px] h-[calc(100vh-100px)]">
      <div className="w-full h-full bg-white border border-gray-200 rounded-[45px] flex flex-col items-center justify-center px-6">
        <img
          src={healthCompassLogo}
          alt="healthcompass Rx"
          className="h-[88px] w-auto mb-8"
        />
        <img
          src={maintenanceIllustration}
          alt="Page not found"
          className="max-h-[160px] md:max-h-[250px] mx-auto mb-10 object-contain"
        />
        <h1 className="text-[32px] md:text-[30px] font-bold text-center mb-4 text-gray-700">
          404 - Page Not Found
        </h1>
        <p className="text-center text-lg md:text-[18px] text-gray-800 mb-8">
          The page you are looking for does not exist or may have been moved.
        </p>
        <button
          type="button"
          onClick={() => navigate('/patients')}
          className="px-7 py-3 rounded-full bg-teal-300 text-white font-semibold hover:bg-teal-400 transition-colors"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
